const baseUrl = "http://football.weball.net";

const requireUrl = baseUrl + "/api";

const redirectUrl = process.env.NODE_ENV === 'development' ? "http://localhost:8080" : baseUrl;//baseUrl;//"http://localhost:8080";

export const TOKEN_KEY = 'token';
export const VCODE_TIME_KEY = 'vcode_time';
export const APPID_KEY = 'appid';
export const PAGE_NUM_KEY = 'page_num';
export default {
    APPID:0,
    homeName:'index',
    baseUrl,
    requireUrl,
    redirectUrl,
    event:{
        subscriptChanged:'subscriptChanged',
        loginChanged:'loginChanged',
        wechatChanged:'wechatChanged',
    },
    getRedirectUrl(){
        let current_domain = window.location.protocol+"//"+window.location.host;
        if(current_domain === redirectUrl){

            return redirectUrl
        }
        else{
            return this.getSystemInfo().redirectUrl;
        }
    },
    setPageNum(pagenum) {
        localStorage.setItem(PAGE_NUM_KEY, pagenum);
    },
    getPageNum(){
        const pagenum = localStorage.getItem(PAGE_NUM_KEY);
        if (pagenum) return pagenum;
        else return history.length;
    },
    setSystemInfo(systemInfo){
        localStorage.setItem('systemInfo', JSON.stringify(systemInfo))
    },
    getSystemInfo(){
        return JSON.parse(localStorage.getItem('systemInfo'))
    },
    setAppId(app_id){
        localStorage.setItem(APPID_KEY, app_id);
    },
    getAppId() {
        const app_id = localStorage.getItem(APPID_KEY);
        if (app_id) return app_id;
        else return this.APPID;
    },
    setToken(token) {
        localStorage.setItem(TOKEN_KEY, token);
    },
    getToken() {
        const token = localStorage.getItem(TOKEN_KEY);
        if (token) return token;
        else return '';
    },
    is_logined(){
        if(this.getToken() === ''){
            return false;
        }
        else{
            return true;
        }
    },
    setVcodeTime(time){
      localStorage.setItem(VCODE_TIME_KEY, time);
    },
    getVcodeTime(){
        const time = localStorage.getItem(VCODE_TIME_KEY);
        if (time) return time;
        else return 0;
    }
}
